import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi, { BackendOptions } from "i18next-http-backend";
import { getDynamicConfig } from "infrastructure/configuration/configurationHelper";
import { loadPortalConfig } from "features/shared/helpers/modules";
import { translationRequest,  } from "features/shared/helpers/translationHelper";
import { getPortalBasename } from "features/shared/helpers/urlHelper";
import { initLanguageDetector } from "features/shared/helpers/languageHelper";
import axios from "axios";

const dynamicConfig = getDynamicConfig();
const portalConfig = loadPortalConfig();

// application allow (has translations) for below listed languages
export const availableLanguages = ["cs", "sk", "en"];

// Konfigurace pro načítání překladů
// V pripade, ze jsou zapnuty custom preklady pro zakazku
// tak se pouzije vlastni f-ce pro nacitani prekladu
const backendOptions: BackendOptions = {
  loadPath: `${portalConfig.enableCustomTranslations ? "" : getPortalBasename()}/locales/{{lng}}/{{ns}}.json?v=${process.env.REACT_APP_VERSION_HASH}`,
  request: portalConfig.enableCustomTranslations ? translationRequest : undefined
};

//load translation using xhr -> see /public/locales
//learn more: https://github.com/i18next/i18next-http-backend
i18n.use(HttpApi).init({
  backend: backendOptions,
});

// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
initLanguageDetector(i18n, availableLanguages);

i18n.on("languageChanged", (language) => {
  // setting localizaction for requests - accept-language
  axios.defaults.headers.common["accept-language"] = language;
});

i18n
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // lng: defaultLang,
    fallbackLng: "cs",
    whitelist: availableLanguages,
    debug: dynamicConfig.enableDebugLogging,
    nsSeparator: '|',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    ns: [],
    detection: {
      
    }
  });

export default i18n;